module.exports = __webpack_public_path__ + "static/investors-info6-947a6ed57829651e19418dd666d25914.jpg";